import { useEffect, useRef } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useDispatch } from "react-redux";
import { getAllServices } from "../../../../store/slices/servicesSlice";
import { useSelector } from "react-redux";
import SubServiceForm from "./subServiceForm";

const CreateSubServiceModal = ({ isOpen, toggle, pagination, onSubServiceCreated }) => {
  const dispatch = useDispatch();
  const subServiceFormRef = useRef();
  const serviceDetails = useSelector((state) => state.services.serviceDetail);

  useEffect(() => {
    dispatch(getAllServices());
  }, [serviceDetails?.ID]);

  const handleCreate = async () => {
    const result = await subServiceFormRef.current.handleSubmit();
    if (result) {
      onSubServiceCreated && onSubServiceCreated();
      toggle();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader>Create Sub Service</ModalHeader>
      <ModalBody>
        <div className="px-2">
          <SubServiceForm
            ref={subServiceFormRef}
            toggle={toggle}
            formType={"create"}
          />
        </div>
      </ModalBody>
      <ModalFooter className="d-flex customModalFooter">
        <button className="btn bg-secondary" onClick={toggle}>
          Cancel
        </button>
        <button className="btn bg-primary" onClick={handleCreate}>
          Create
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateSubServiceModal;
